import axios from "axios";
import { API_URL } from "../constants";
import {
  AssistantConversation,
  AssistantMessage,
  SendPromptResult,
} from "../types/Assistant";

export async function fetchConversations(
  companyId: string
): Promise<AssistantConversation[]> {
  const res = await axios.get(`${API_URL}/${companyId}/assistant/conversations`);
  return (res.data?.conversations || []) as AssistantConversation[];
}

/**
 * Create the conversation up front so the socket room can be joined before the
 * first question is asked — otherwise the first reply can never stream.
 */
export async function createConversation(
  companyId: string
): Promise<AssistantConversation> {
  const res = await axios.post(`${API_URL}/${companyId}/assistant/conversations`, {});
  return res.data.conversation as AssistantConversation;
}

export async function fetchMessages(
  companyId: string,
  conversationId: string
): Promise<AssistantMessage[]> {
  const res = await axios.get(
    `${API_URL}/${companyId}/assistant/conversations/${conversationId}/messages`
  );
  return (res.data?.messages || []) as AssistantMessage[];
}

/**
 * Ask the assistant. Text also arrives progressively over the socket, but this
 * response is the authoritative answer — if the socket is down the UI still
 * gets the full message here.
 */
export async function sendPrompt(
  companyId: string,
  conversationId: string | null,
  content: string
): Promise<SendPromptResult> {
  const res = await axios.post(`${API_URL}/${companyId}/assistant/messages`, {
    conversationId,
    content,
  });
  return res.data as SendPromptResult;
}
